"use client";

import * as React from "react";
import { useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
const faqs = [{
  question: "カウンセリングはどんなことをするのですか？",
  answer: "ご相談される方の悩みや困りごとについて、まずは丁寧にお話を伺いながら、ご希望やお気持ちを尊重し、解決策を一緒に考えていきます。"
}, {
  question: "どんな人がカウンセリングを受けるのですか？",
  answer: <>精神的な病を抱えている方が受けるイメージがあるかもしれませんが、人間関係や仕事上の悩み、家族の問題などカウンセリングを受ける理由は人によりさまざまです。具体的なご相談内容については<a href="https://s-office-k.com/complaint" target="_blank" rel="noopener noreferrer" className="underline text-primary-heading">相談内容一覧（心理オフィスｋ様のサイトへリンクします）</a>をご参考ください。カウンセリングを受けようか迷っておりましたら、一度お問い合わせください。</>
}, {
  question: "本人が行かなければいけないのでしょうか？",
  answer: "ご本人がいらっしゃらなくても大丈夫です。困りごとを抱えているご本人にどう接したらいいのか悩まれている方も少なくありません。迷われた場合はお気軽にお問い合わせください。"
}];
export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section data-section-id="257282" id="faq" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">

        <div className="mb-10">
          <span className="inline-block w-fit bg-primary text-primary-foreground text-sm font-bold px-3 py-1 rounded-sm mb-4">よくあるご質問</span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">はじめての方から<br />よくいただくご質問</h2>
          <Separator className="w-12 h-0.5 bg-primary" />
        </div>

        <div className="border-t border-border">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} data-index={i} className="border-b border-border">
                <h3 className="m-0">
                  <button type="button" id={`home-faq-question-${i}`} aria-expanded={isOpen} aria-controls={`home-faq-answer-${i}`} onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left font-default text-base md:text-lg font-bold text-foreground">
                    <span className="flex-1">{faq.question}</span>
                    <svg className={`size-5 shrink-0 text-primary transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </button>
                </h3>

                {/* 常にDOMに存在させ、高さのみCSSで制御する */}
                <div id={`home-faq-answer-${i}`} role="region" aria-labelledby={`home-faq-question-${i}`} className={`overflow-hidden transition-all duration-300 ease-out ${isOpen ? "max-h-[800px] opacity-100" : "max-h-0 opacity-0"}`}>
                  <div className="font-default text-foreground leading-relaxed pb-6">
                    {faq.answer}
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="pt-12 flex justify-center">
          <Button asChild variant="outline" size="lg" className="border-primary text-primary-heading hover:bg-primary/10 px-8 rounded-lg">
            <Link to="https://yotsuya-sc-room.com/faq/">よくある質問をもっと見る</Link>
          </Button>
        </div>
      </div>
    </section>;
}